import { useState, useEffect } from "react";
import { getHoursCloseTicketsAuto } from "../../config";
import toastError from "../../errors/toastError";

import api from "../../services/api";
import { dispatchTicketUpdated } from "../../utils/ticketEvents";

const useTickets = ({
    searchParam,
    pageNumber,
    status,
    date,
    showAll,
    queueIds,
    labelIds,
    connectionIds,
    userIds,
    contactType,
    funnelId,
    funnelStageId,
    refreshToken,
    withUnreadMessages,
}) => {
    const [loading, setLoading] = useState(true);
    const [hasMore, setHasMore] = useState(false);
    const [tickets, setTickets] = useState([]);
    const [count, setCount] = useState(0);

    useEffect(() => {
        let cancelled = false;
        setLoading(true);
        setTickets([]);
        setHasMore(false);
        setCount(0);

        const fetchTickets = async() => {
            try {
                const { data } = await api.get("/tickets", {
                    params: {
                        searchParam,
                        pageNumber,
                        status,
                        date,
                        showAll,
                        queueIds,
                        labelIds,
                        connectionIds,
                        userIds,
                        contactType,
                        funnelId,
                        funnelStageId,
                        withUnreadMessages,
                    },
                })
                if (cancelled) return;
                setTickets(data.tickets)

                let horasFecharAutomaticamente = getHoursCloseTicketsAuto(); 

                if (status === "open" && horasFecharAutomaticamente && horasFecharAutomaticamente !== "" &&
                    horasFecharAutomaticamente !== "0" && Number(horasFecharAutomaticamente) > 0) {

                    let dataLimite = new Date()
                    dataLimite.setHours(dataLimite.getHours() - Number(horasFecharAutomaticamente))

                    data.tickets.forEach(ticket => {
                        if (ticket.status !== "closed") {
                            let dataUltimaInteracaoChamado = new Date(ticket.updatedAt)
                            if (dataUltimaInteracaoChamado < dataLimite)
                                closeTicket(ticket)
                        }
                    })
                }

                setHasMore(data.hasMore)
                setCount(data.count)
                setLoading(false)
            } catch (err) {
                if (cancelled) return;
                setLoading(false)
                toastError(err)
            }
        }

        const closeTicket = async(ticket) => {
            const { data } = await api.put(`/tickets/${ticket.id}`, {
                status: "closed",
                userId: ticket.userId || null,
            })
            dispatchTicketUpdated(data)
        }

        fetchTickets()
        return () => {
            cancelled = true;
        }
    }, [
        searchParam,
        pageNumber,
        status,
        date,
        showAll,
        queueIds,
        labelIds,
        connectionIds,
        userIds,
        contactType,
        funnelId,
        funnelStageId,
        refreshToken,
        withUnreadMessages,
    ])

    return { tickets, loading, hasMore, count };
};

export default useTickets;

